import React from "react";
import "./bannerShine.css";

const MyWashBanner = () => {
  return (
    <a
      href="https://mywash.rs"
      target="_blank"
      rel="noopener noreferrer"
      className="banner-shine"
      style={{
        background: "linear-gradient(135deg, #33A5FF 0%, #1a7fd4 100%)",
        borderRadius: "1rem",
        padding: "1.2rem 1.5rem",
        margin: "1rem 0",
        cursor: "pointer",
        transition: "all 0.3s ease",
        boxShadow: "0 4px 15px rgba(51, 165, 255, 0.25)",
        color: "white",
        display: "flex",
        alignItems: "center",
        gap: "1rem",
        textDecoration: "none",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = "0 6px 25px rgba(51, 165, 255, 0.4)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "none";
        e.currentTarget.style.boxShadow = "0 4px 15px rgba(51, 165, 255, 0.25)";
      }}
    >
      <img
        src="https://partneri.mywash.rs/assets/mywash-logo.png"
        alt="MyWash"
        style={{
          width: "50px",
          height: "50px",
          borderRadius: "12px",
          flexShrink: 0,
          background: "rgba(255,255,255,0.15)",
          padding: "5px",
          position: "relative",
          zIndex: 2,
        }}
      />
      <div style={{ flex: 1, minWidth: 0, position: "relative", zIndex: 2 }}>
        <div style={{ fontSize: "1.5rem", fontWeight: "800", lineHeight: 1.15 }}>
          Žetoni za pranje u telefonu
        </div>
        <div style={{ fontSize: "1rem", opacity: 0.9, marginTop: "2px" }}>
          Lojalne mušterije · Partnerske firme · Bez kovanica
        </div>
      </div>
      <div style={{
        padding: "0.4rem 1rem",
        background: "rgba(255,255,255,0.2)",
        borderRadius: "0.5rem",
        fontWeight: "700",
        fontSize: "0.9rem",
        border: "1px solid rgba(255,255,255,0.3)",
        whiteSpace: "nowrap",
        flexShrink: 0,
        position: "relative",
        zIndex: 2,
      }}>
        Saznajte više →
      </div>
    </a>
  );
};

export default MyWashBanner;
